<template>
  <div id="app">
    <transition name="ready" mode="out-in">
      <Ready v-if="!isReady"/>
      <div v-else class="app__view__wrapper">
        <header id="app-head">
          <TestvNav class="comp__TestvNav" :back="$route.meta.back" />
        </header>
        <transition name="fade" mode="out-in">
          <keep-alive :include="['Home', 'Catalog', 'Member']">
            <router-view/>
          </keep-alive>
        </transition>
        <TestvBackToTop class="btn__backToTop" :stickers="pageData.stickers"/>
      </div>
    </transition>

    <!-- 登录弹窗 -->
    <ss-login-dialog
      ref="loginDialog"
      v-if="terminalType === 'pc'"
      :terminalType="terminalType"
      :setting="setting">
    </ss-login-dialog>
  </div>
</template>

<script>
import { initWx } from '@/utils/share.js'
import TestvNav from '@/components/TestvNav/index.vue'
import TestvBackToTop from '@/components/TestvBackToTop/index.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import Ready from '@/views/Ready/index.vue'
import debounce from 'lodash/debounce'
import {
  SsLoginDialog
} from 'sspai-ui'

export default {
  name: 'App',

  components: {
    TestvNav,
    TestvBackToTop,
    Ready,
    SsLoginDialog
  },

  data () {
    return {
      isReady: false
    }
  },

  computed: {
    ...mapState(['pageData', 'series', 'setting', 'terminalType'])
  },

  methods: {
    ...mapActions(['login', 'updateUserInfo', 'updatePageData', 'updateSiteSetting', 'updateSeries']),
    ...mapMutations(['logout', 'setToken', 'setTerminalType']),
    onLogout () {
      this.logout()
      this.$toast({
        message: '您已安全登出。',
        type: 'success'
      })
      window.location.reload()
    },
    async onLoginSuccess (data, msg) {
      this.login(data)
      await this.updateUserInfo()
      this.$toast({
        message: msg || '欢迎回来！',
        type: 'success'
      })
      if (this.$refs.loginDialog && this.$refs.loginDialog.dialogIsShow()) {
        this.$bus.$emit('closeLogin')
      }
      await this.subscribe(true)
    },
    initTerminalType: debounce(function () {
      if (document.body.clientWidth >= 1112) {
        this.setTerminalType('pc')
      } else if (document.body.clientWidth < 768) {
        this.setTerminalType('phone')
      } else {
        this.setTerminalType('iPad')
      }
    }, 100),
    async subscribe (reload) {
      const url = window.sessionStorage.getItem('subscribe')
      await this.updateSeries(this.pageData.series)
      if (this.series && this.series.is_pay && !this.series.is_expire) {
        this.isReady = true
      }
      // 试读
      if (this.$route.query.freeTrial) {
        this.isReady = true
      }
      const jump = url && !(url.includes('/order/confirm/') && this.isReady)
      if (jump) {
        console.log(jump)
        window.sessionStorage.setItem('subscribe', '')
        this.$openLink(url, '_self')
        return
      }
      reload && window.location.reload()
    }
  },

  async created () {
    if (window.location.pathname.includes('/series/371')) {
      this.$router.replace({ name: 'Home' })
    }
    initWx(this.pageData.share.image, this.pageData.share.description)
    this.initTerminalType()
    const ssToken = window.localStorage.getItem('ssToken')
    if (ssToken) {
      this.setToken({ token: ssToken })
      this.updateUserInfo()
    } else {
      this.logout()
    }
    await this.updatePageData()
    this.updateSiteSetting()
    this.subscribe()
  },

  mounted () {
    // 登录成功
    this.$bus.$on('loginSuccess', this.onLoginSuccess)
    // 注册成功
    this.$bus.$on('registerSuccess', this.onLoginSuccess)
    this.$bus.$on('gtag', (eventName, eventParams) => {
      try {
        window.gtag('event', eventName, eventParams)
      } catch (error) {
        console.log(error)
      }
    })
    this.$bus.$on('logout', this.onLogout)
    window.addEventListener('resize', this.initTerminalType)
  },

  destroyed () {
    this.$bus.$off('loginSuccess')
    this.$bus.$off('gtag')
    this.$bus.$off('logout')
    this.$bus.$off('registerSuccess')
    window.removeEventListener('resize', this.initTerminalType)
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/styles/variable.styl"
#app {
  padding-left: constant(safe-area-inset-left);
  padding-right: constant(safe-area-inset-right);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  overflow-x: hidden;
  --h-header: 56px;
  @media (min-width: $screen-md) {
    --h-header: 60px;
  }

  >>> button {
    border: none;
    cursor: url('~@/assets/images/pointer@1x.png') 7 0, pointer;
  }

  >>> a {
    color: inherit;
    cursor: url('~@/assets/images/pointer@1x.png')7 0, pointer;
    &:hover {
      color: inherit;
    }
  }

  .btn__backToTop {
    position: fixed;
    bottom: 0px;
    right: 0px;
    z-index: 99;
    @media (min-width: $screen-md) {
      right: 16px;
    }
  }
}

header {
  height: var(--h-header);
  .comp__TestvNav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    box-sizing: border-box;
    z-index: 99;
  }
}

.app__view__wrapper {
  overflow: hidden;
}

.fade-enter-active,
.fade-leave-active {
  transition: all .3s ease;
}
.fade-enter
.fade-leave-to {
  transform: translateY(30px);
  opacity: 0;
}

.ready-enter-active,
.ready-leave-active {
  transition: opacity .3s ease;
}
.ready-enter
.ready-leave-to {
  opacity: 0;
}
</style>
